import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@mui/material';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface ActionPage {
  isLoading: boolean;
}

const styling = {
  buttonStyle: { width: '130px' },
};

export const FormButtons = ({ isLoading }: ActionPage) => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate(`/masters/employee`);
  };
  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container justifyContent="space-between" spacing={1}>
      <Grid item>
        <Button variant="outlined" style={styling.buttonStyle} onClick={onCancel}>
          Cancel
        </Button>
      </Grid>
      <Grid item>
        <Button
          type={'submit'}
          disabled={isLoading||isReadOnlyPermission}
          variant="contained"
          disableElevation={true}
          style={styling.buttonStyle}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
};
